"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBadge = StatusBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var COLOR_CLASSES = {
    navy: "bg-primary-navy text-white",
    green: "bg-primary-green text-white",
    "green-soft": "bg-green-100 text-green-700",
    amber: "bg-amber-100 text-amber-700",
    red: "bg-red-100 text-red-700",
    "red-solid": "bg-red-600 text-white",
    blue: "bg-blue-100 text-blue-700",
    gray: "bg-gray-100 text-gray-600",
};
function StatusBadge(props) {
    var color = props.color, children = props.children;
    return ((0, jsx_runtime_1.jsx)("span", { className: "inline-flex items-center gap-1.5 rounded-md px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ".concat(COLOR_CLASSES[color]), children: children }));
}
